import ApiRoutes from "../../../../constants/api-routes";
import { hneAdsApi } from "../../../../service";

export const createNewAdvertisement = async (body) =>
  hneAdsApi.post(`${ApiRoutes.CREATE_NEW_ADVERTISEMENT}`, body);

export const updateAdvertisement = async (body, advertisement_id) =>
  hneAdsApi.put(`${ApiRoutes.UPDATE_ADVERTISEMENT}/${advertisement_id}`, body);

export const getAllAdvertisement = async (body) =>
  hneAdsApi.get(`${ApiRoutes.GET_ALL_ADVERTISEMENT}`, body);

export const getAdvertisementByPlacement = async (placement, ad_space, count) =>
  hneAdsApi.get(
    `${ApiRoutes.GET_ALL_ADVERTISEMENT_BY_PLACEMENT}?placement=${placement}&ad_space=${ad_space}&count=${count}`
  );

export const getAllAdvCategory = async (body) =>
  hneAdsApi.get(`${ApiRoutes.GET_ALL_ADV_CATEGORY}`, body);

export const getAllAdvSubCategory = async (body) =>
  hneAdsApi.get(`${ApiRoutes.GET_ALL_SUBCATEGORY}`, body);

export const createSuperCategory = async (body) =>
  hneAdsApi.post(`${ApiRoutes.CREATE_ADV_CATEGORY}`, body);

export const createSubCategory = async (body) =>
  hneAdsApi.put(`${ApiRoutes.UPDATE_ADV_SUB_CATEGORY}`, body);

export const updateAdvSubCategory = async (
  body,
  category_id,
  sub_category_id
) =>
  hneAdsApi.put(
    `${ApiRoutes.UPDATE_ADV_CATEGORY}/${category_id}/${sub_category_id}`,
    body
  );

export const updateAdvertisementStatus = async (body, advertisement_id) =>
  hneAdsApi.put(
    `${ApiRoutes.UPDATE_ADVERTISEMENT_STATUS}/${advertisement_id}`,
    body
  );

export const deleteAdvertisement = async (advertisement_id) =>
  hneAdsApi.delete(`${ApiRoutes.DELETE_ADVERTISEMENT}/${advertisement_id}`);
